<template>
  <v-flex>
    <vue-tel-input
      v-model="input"
      :placeholder="label"
      :name="label"
      :value="value"
      :preferred-countries="['CRO']"
      enabled-country-code
      :valid-characters-only="true"
      :required="validator ? validator.required : null"
      class="tel-input-style"
      @input="$emit('input', $event)"
      @blur="validator && validator.$touch()"
    />
    <p v-if="getErrors(validator).length" class="error--text pl-3 error-font-size">
      {{ getErrors(validator)[0] }}
    </p>
  </v-flex>
</template>

<script>
import { defaultMessages, getValidationErrors } from '@/utils'
import { VueTelInput } from 'vue-tel-input'

export default {
  name: 'phone-number-field',
  components: {
    VueTelInput,
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    validator: {
      type: Object,
      default: null,
    },
    errorMessages: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      input: '',
    }
  },
  mounted() {
    if (this.value) {
      this.input = this.value
    }
  },
  methods: {
    getErrors: function (field) {
      return getValidationErrors({
        ...defaultMessages,
        ...this.errorMessages,
      })(field)
    },
  },
}
</script>

<style scoped>
.container {
  display: flex;
}
.tel-input-style {
  color: #333333;
  height: 56px;
  border-bottom: 2px solid #979797;
  border-left: 0;
  border-right: 0;
  border-top: 0;
  background: #f5f5f5;
  font-size: 16px;
  line-height: 24px;
  box-shadow: none;
  margin-bottom: 8px;
}
.tel-input-style:active {
  color: #0277bd !important;
}
.tel-input-style:hover {
  background-color: rgba(2, 119, 189, 0.2);
}
.country-codes {
  width: 40%;
}
.error-font-size {
  font-size: 12px;
}
</style>
